import withHandlers from 'recompose/withHandlers';
import sortBy from 'lodash/fp/sortBy';
import filter from 'lodash/fp/filter';
import flow from 'lodash/fp/flow';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import {
  getActiveBarberId,
  getSelectedBrand,
  getSelectedCategory,
  getProductSearch,
} from '../selectors';
import { addProduct } from '../../order/actions';
import ProductList from '../components/ProductList';
import withProducts from '../../../products/products/hoc/withProducts';
import { getSelectedProducts } from '../../order/selectors';

const fieldsForSearch = ['name', 'sku'];

const ProductListContainer = compose(
  withProducts,
  connect(
    (state, ownProps) => {
      const productCategoryId = getSelectedCategory(state);
      const productBrandId = getSelectedBrand(state);
      const productSearch = getProductSearch(state);
      const filterProducts = flow(
        filter((item) => {
          if (!item.isRetail) return false;
          if (item.ownerType === 'barber' && getActiveBarberId(state) !== item.ownerId) return false;
          if (productSearch) return fieldsForSearch.some((field) => (
            (item[field] || '').toLowerCase().includes(productSearch.toLowerCase().trim())
          ));
          if (productCategoryId) return item.productCategoryId === productCategoryId;
          if (productBrandId) return item.productBrandId === productBrandId;

          return !item.productCategoryId && !item.productBrandId;
        }),
        sortBy('name'),
      );
      return {
        products: filterProducts(ownProps.products),
        selectedProducts: getSelectedProducts(state, getActiveBarberId(state)),
        activeBarberId: getActiveBarberId(state),
      };
    },
    { addProduct },
  ),
  withHandlers({
    addItem: props => id => props.addProduct(props.activeBarberId, id),
  })
)(ProductList);

export default ProductListContainer;
